import { render } from "./promotionTable.vue?vue&type=template&id=abf49ca6&scoped=true"
import script from "./promotionTable.vue?vue&type=script&lang=js"
export * from "./promotionTable.vue?vue&type=script&lang=js"

import "./promotionTable.vue?vue&type=style&index=0&id=abf49ca6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abf49ca6"]])

export default __exports__